import { useSearchParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useActivateAccount } from "../../hooks/queries/useAuthQueries";
import CustomUnauthorized from "../../components/ui/CustomUnauthorized/CustomUnauthorized";
import { usePasswordForm } from "./hooks/usePasswordForm";
import PasswordPageWrapper from "../../components/auth/PasswordPageWrapper/PasswordPageWrapper";
import { toastService } from "../../providers";
import { extractAxiosErrorMessage } from "../../services/utils/errorUtils";

function NewPassword() {
  const [searchParams] = useSearchParams();
  const activationToken = searchParams.get("token");
  const navigate = useNavigate();
  const [isTokenExpired, setIsTokenExpired] = useState(false);

  const { mutate: activateAccount, isPending } = useActivateAccount();
  const { control, handleSubmit, validations } = usePasswordForm();

  const onSubmit = (values) => {
    activateAccount(
      {
        token: activationToken,
        password: values.password,
      },
      {
        onSuccess: () => {
          toastService.success("Account activated. Proceed to login.");
          navigate("/auth/login");
        },
        onError: (error) => {
          const errorMessage = extractAxiosErrorMessage(error);

          const isExpired =
            errorMessage.toLowerCase().includes("activation token") &&
            (errorMessage.toLowerCase().includes("expired") ||
              errorMessage.toLowerCase().includes("already used"));

          setIsTokenExpired(isExpired);
          toastService.error(
            isExpired
              ? "Activation token has expired."
              : "Something went wrong! Please try again.",
          );
        },
      },
    );
  };

  if (!activationToken) {
    return (
      <CustomUnauthorized
        leftTitle="Access Denied!"
        leftMessage="Please ensure you clicked the full link from your email."
        actions={[
          {
            label: "Back To Home",
            href: "/",
          },
        ]}
      />
    );
  }

  return (
    <PasswordPageWrapper
      title="New Password"
      subtitle="Set up a new password to access your account"
      control={control}
      onSubmit={handleSubmit(onSubmit)}
      isSubmitting={isPending}
      validationRules={validations}
      buttonLabel="Set Password"
      isTokenExpired={isTokenExpired}
      onResendActivation={() => navigate("/auth/request-reactivation")}
    />
  );
}

export default NewPassword;
